import type { IconData } from '@stacksjs/iconify-core'

export const heartRatePulseGraph: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M42.778 26.437c2.06-3.301 2.73-7.39 1.834-11.194c-1.914-8.662-12.51-12.201-19.11-6.396c-.523.456-.988.983-1.502 1.508c-.514-.525-.98-1.052-1.502-1.508c-6.6-5.805-17.196-2.266-19.11 6.396c-.895 3.803-.225 7.893 1.834 11.194c3.603 5.786 9.413 10.29 15.08 14.374a6.34 6.34 0 0 0 7.396 0c5.667-4.083 11.477-8.588 15.08-14.374\"/><path d=\"M9 23h6l3.5-6L24 30l6-16l4 9h5\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default heartRatePulseGraph
